<template>
  <div class="recommend">
    <div class="tab-box" ref="tab">
      <h2 class="title">精选好物9.9元起</h2>
      <div class="tab">
        <span v-for="(text, index) in tabs" :key="text" @click="swichTab(index)" :class="{'on':index === tabCurrent}">{{text}}</span>
      </div>
    </div>
    <div class="fixed-bar" v-if="showTopFix" ref="fixedbar">
       <span v-for="(text, index) in tabs" :key="text" @click="swichTab(index)" :class="{'on':index === tabCurrent}">{{text}}</span>
    </div>
    <mt-loadmore :bottom-method="loadMore" :bottom-all-loaded="noMore && tabCurrent === tabs.length -1" ref="loadmore">
      <goods-list :goodsList="goodsList" :shopId="shopId" :tabCurrent="tabCurrent"></goods-list>
    </mt-loadmore>
  </div>
</template>
<script>
import Vue from 'vue'
import { Loadmore } from 'mint-ui'
import GoodsList from './GoodsListApplet.vue'
import YunJi from '@/assets/js/YunJi'
import * as Http from '@/pages/commodity/api/share'
import * as Util from '@/assets/js/Util'
Vue.component(Loadmore.name, Loadmore)

export default {

  data() {
    return {
      tabs: [
        '9.9包邮专区',
        '品质水果',
        '今日特卖'
      ],
      tabCurrent: 0,
      goodsList: [],
      appCont: YunJi.getUrlParams('appCont') || 0, // 客户端标识 0-H5，1-卖家版，2-买家版
      shopId: YunJi.getUrlParams('shopId'), // 店铺id
      page: {
        pageIndex: 0,
        pageSize: 18
      },
      isLoading: false,
      showTopFix: false,
      noMore: false,
      ABtestId: YunJi.getUrlParams('ABtestId') || ''
    }
  },
  components: {
    GoodsList
  },
  methods: {
    /**
     * 获取推荐商品
     */
    getAiGoodsList() {
      let that = this
      if (this.page.pageIndex) {
        this.isLoading = true
      }
      Http.queryNavigationItemList({
        type: this.tabCurrent + 1,
        pageSize: this.page.pageSize,
        pageIndex: this.page.pageIndex
      }).then((res) => {
        this.isLoading = false
        if (res.errorCode == 0 && res.data) {
          const tempList = res.data.itemBoList || []
          this.goodsList.push(...tempList)
          this.page.pageIndex += 1
          if (tempList.length < this.page.pageSize) {
            this.noMore = true
          }
          let ids = Util.exposureThinkingReport()
          let params = {
            ids: ids.join(','),
            tabName: that.tabCurrent === 0 ? '9.9包邮专区' : that.tabCurrent === 1 ? '品质水果' : '今日特卖',
          }
          ids && wx.miniProgram && wx.miniProgram.postMessage({data: JSON.stringify(params)})
        }
      })
    },
    swichTab(index) {
      this.tabCurrent = index
      this.initList()
      window.thinkingReport.track('others', {
        page_id: '80612',
        point_id: '25854',
        'ABtestId': this.ABtestId,
        tab_name: index === 0 ? '9.9包邮专区' : index === 1 ? '品质水果' : '今日特卖',
      })
      console.log(index)
    },
    initList() {
      this.goodsList = []
      this.noMore = false
      this.page = {
        pageIndex: 0,
        pageSize: 18
      }
      setTimeout(() => {
        this.getAiGoodsList()
      }, 50)
    },
    loadMore() {
      if (this.isLoading) {
        return
      }
      if (this.noMore) {
        if (this.tabCurrent < this.tabs.length - 1) {
          this.tabCurrent = this.tabCurrent + 1
          this.swichTab(this.tabCurrent)
        }
      } else {
        this.pageIndex = this.pageIndex + 1
        this.getAiGoodsList()
      }
      console.log('isLoading', this.isLoading)
      console.log('noMore', this.noMore)
    }
  },
  mounted() {
    let that = this
    this.getAiGoodsList()
    // console.log("goodsList", this.goodsList);
    let scrollTimer = null
    window.onscroll = () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // 110
      // 230
      const startPos = YunJi.remToPx(2.26)
      if (scrollTop > this.$refs.tab.offsetTop + startPos) {
        this.showTopFix = true
        // this.$refs.topbar.style.opacity = (scrollTop - startPos) / 12 * 0.1
      } else {
        this.showTopFix = false
      }
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        let ids = Util.exposureThinkingReport()
        let params = {
          ids: ids.join(','),
          tabName: that.tabs[that.tabCurrent].title
        }
        ids && wx.miniProgram && wx.miniProgram.postMessage({data: JSON.stringify(params)})
      }, 300);
    }
  }
}
</script>
<style lang="less" scoped>
.recommend{
  overflow: hidden;
  background:#f2f2f2;
  min-height: 100vh;
}
.tab-box {
  height: 2.26rem;
  background: url('//static.yunjiglobal.com/qnUpload/frontend/shareCloud/tab-bg.png') no-repeat top center;
  background-size: 100% auto;
  overflow: hidden;
  padding:0 0.54rem;
  .title {
    text-align: center;
    font-size: 0.36rem;
    color: #262626;
    height: 0.5rem;
    margin-top: 0.39rem;
    font-weight: 600;
  }
  .tab {
    margin-top: 0.28rem;
    display: flex;
    justify-content: space-around;
    span {
      color: #262626;
      font-size: 0.3rem;
      &.on {
        color: #EE2532;
        border-bottom: 2px solid #EE2532;
      }
    }
  }
}
     
.fixed-bar {
  position: fixed;
  z-index: 100;
  top: 0;
  width: 100%;
  height: 0.96rem;
  line-height: 0.96rem;
  background: #FFFFFF;
  padding-left: 0.56rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  span {
    color: #262626;
    font-size: 0.3rem;
    margin-right:0.4rem;
    height: 0.48rem;
    line-height: 0.48rem;
    &.on {
      color: #EE2532;
      border-bottom: 2px solid #EE2532;
    }
  }
}
</style>
